export default __webpack_public_path__ + "static/media/breakfast-overlay.cb4236a9.png";